module.exports = __webpack_public_path__ + "5.0.2/img/pic_2.36312d75.png";